import { useMemo } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';

import { createAppTheme } from './Theme';

export default function LocaleThemeProvider({ children }) {
  const theme = useMemo(() => createAppTheme(), []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
